// extracted by mini-css-extract-plugin
export default {"container":"BoldButton-module__container__2L1Qq","primary":"BoldButton-module__primary__+Sbsk","label":"BoldButton-module__label__HvRu1"};